import React from 'react';
import styles from './adminreport.module.scss';

// tab components
import Company from './company';
import Country from './country';
import Industry from './industry';
import {NavTabsEnum} from 'utils/constants';
import {useVisibleSubTabs} from 'utils/useVisibleSubTabs';

const REPORT_SUBTABS = [
  {key: 'company', value: 'COMPANY', label: 'Company'},
  {key: 'country', value: 'COUNTRY', label: 'Country'},
  {key: 'industry', value: 'INDUSTRY', label: 'Industry'},
  {
    key: 'expert-interviews',
    value: 'EXPERT INTERVIEWS',
    label: 'Expert Interviews',
  },
];

const AdminReports = () => {
  const [activeTab, setActiveTab] = React.useState('COMPANY');
  const {visibleSubTabs, visibleKeys, firstVisible} = useVisibleSubTabs(
    NavTabsEnum.Report,
    REPORT_SUBTABS,
  );

  // Keep the active tab on something the admin can actually see.
  React.useEffect(() => {
    const current = REPORT_SUBTABS.find(sub => sub.value === activeTab);
    if (firstVisible && (!current || !visibleKeys.includes(current.key))) {
      setActiveTab(firstVisible.value);
    }
  }, [firstVisible, visibleKeys, activeTab]);

  return (
    <div className={styles.container}>
      <section className={styles.header}>
        <h1>Reports</h1>
      </section>
      <section className={styles['sections-tab']}>
        <div className={styles['verifier-toggler']}>
          {visibleSubTabs.map(tab => (
            <span
              key={tab.key}
              onClick={() => setActiveTab(tab.value)}
              className={activeTab === tab.value ? styles['active-tab'] : ''}>
              {tab.label}
            </span>
          ))}
        </div>
      </section>
      {/* Tab Components */}
      {activeTab === 'COMPANY' && <Company />}
      {activeTab === 'INDUSTRY' && <Industry />}
      {activeTab === 'COUNTRY' && <Country />}
    </div>
  );
};

export {AdminReports};
